<template>
  <div id="wrap"></div>
</template>
<script>
import {GaTracking} from "@/mixins/index.js";

export default {
  mixins: [GaTracking],
  name: "app",

  data: () => ({
  }),
  computed: {
  },
  methods: {
  }
};
</script>
<style>
</style>